import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TipoAssinaturaService {

  STORAGE_KEY = 'flagBooleano';
  
  constructor() { }

  set valor(valor: boolean) {
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(valor));
  }

  get valor(): boolean {
    const raw = sessionStorage.getItem(this.STORAGE_KEY);
    return raw !== null ? JSON.parse(raw) : false;
  }

  clear() {
    sessionStorage.removeItem(this.STORAGE_KEY);
  }
}
